import React from 'react';
import {injectIntl} from "react-intl";
import moment from "moment";
import Constants from "../../../services/Constants";
import WarningText from "../../common/text/WarningText";

class LeasebaseContract extends React.Component {

  render() {
    const {intl: {formatMessage, formatNumber}, contract} = this.props;

    if (!contract) {
      return null;
    }

    const {usageStatus, endDate, endMileage, contractType, assistance, maintenance, repair, carWash, replacementVehicle, pickupReturnService, summerTires, winterTires} = contract;
    return (
      <div>
          {usageStatus === 'EXCEEDING' &&
            <div>
              <WarningText text={formatMessage({id: 'error.above.foreseen.usage'})}/>
              <br/>
            </div>
          }

        {endDate &&
          <span className="txt-muted">{formatMessage({id: 'contract.valid.until'}, {date:moment(endDate).format(Constants.DATE_FORMAT_DISPLAY), mileage:formatNumber(endMileage)})} </span>
        }
          <ul className="list-bordered list--array">
            <li>
              <span className="list__key">{formatMessage({id: 'contract.leasebase.services.title'})}:</span>

              <span className="list__value">{formatMessage({id: `contract.${contractType.toLowerCase()}`})}</span>


            </li>
            <li>
              <span className="list__key">{formatMessage({id:'contract.leasebase.maintenance'})}:</span>
              <span className="list__value">{maintenance && formatMessage({id: `${maintenance.toLowerCase()}`})}</span>
            </li>
            <li>
              <span className="list__key">{formatMessage({id:'contract.leasebase.assistance'})}:</span>
              <span className="list__value">{assistance && formatMessage({id: `${assistance.toLowerCase()}`})}</span>
            </li>
            <li>
              <span className="list__key">{formatMessage({id:'contract.leasebase.repair'})}:</span>
              <span className="list__value">{repair && formatMessage({id: `${repair.toLowerCase()}`})}</span>
            </li>
            <li>
              <span className="list__key">{formatMessage({id:'contract.leasebase.car-wash'})}:</span>
              <span className="list__value">{carWash && formatMessage({id: `${carWash.toLowerCase()}`})}</span>
            </li>
            <li>
              <span className="list__key">{formatMessage({id:'contract.leasebase.rental-car'})}:</span>
              <span className="list__value">{replacementVehicle && formatMessage({id: `${replacementVehicle.toLowerCase()}`})}</span>
            </li>
            <li>
              <span className="list__key">{formatMessage({id:'contract.leasebase.home-service'})}:</span>
              <span className="list__value">{pickupReturnService && formatMessage({id: `${pickupReturnService.toLowerCase()}`})}</span>
            </li>
            <li>
              <span className="list__key">{formatMessage({id:'contract.leasebase.tires.summer'})}:</span>
              <span className="list__value">{summerTires && formatMessage({id: `${summerTires.toLowerCase()}`})}</span>
            </li>
            <li>
              <span className="list__key">{formatMessage({id:'contract.leasebase.tires.winter'})}:</span>
              <span className="list__value">{winterTires && formatMessage({id: `${winterTires.toLowerCase()}`})}</span>
            </li>
          </ul>
      </div>
    )
  }
}

export default injectIntl(LeasebaseContract);



// WEBPACK FOOTER //
// ./src/components/interventiondetail/contracts/LeasebaseContract.js